import { render } from "./process-reports-locked.vue?vue&type=template&id=21c5223e&scoped=true&ts=true"
import script from "./process-reports-locked.vue?vue&type=script&lang=ts"
export * from "./process-reports-locked.vue?vue&type=script&lang=ts"

import "./process-reports-locked.vue?vue&type=style&index=0&id=21c5223e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c5223e"]])

export default __exports__